import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { DateTime } from 'luxon';
import { distinctUntilChanged } from 'rxjs';
import { DictionaryParameterService } from 'src/app/shared';
import { ErrorDialogComponent } from 'src/components/shared/error-dialog/error-dialog.component';

export interface ParameterDialogData {
  parameter: string;
  dateFrom: DateTime;
  dateTo: DateTime;
  value: number;
  errorMessage?: string;
  parameterNames: string[];
}

@Component({
  standalone: false,
  selector: 'app-dictionaries-parameters-add-new-dialog',
  templateUrl: './dictionaries-parameters-add-new-dialog.component.html',
  styleUrl: './dictionaries-parameters-add-new-dialog.component.scss',
})
export class DictionariesParametersAddNewDialogComponent implements OnInit {
  parameterForm: FormGroup;

  constructor(
    public dialogRef: MatDialogRef<DictionariesParametersAddNewDialogComponent>,
    private parameterService: DictionaryParameterService,
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: ParameterDialogData
  ) {
    this.parameterForm = new FormGroup({
      parameter: new FormControl('', Validators.required),
      dateFrom: new FormControl('', Validators.required),
      dateTo: new FormControl('', Validators.required),
      value: new FormControl('', {
        validators: [
          Validators.required,
          Validators.pattern('^[0-9]+([.][0-9]{1,3})?$'),
          Validators.maxLength(10),
        ],
      }),
    });
  }

  ngOnInit(): void {
    this.parameterForm.controls.value.valueChanges
      .pipe(distinctUntilChanged())
      .subscribe((value: number) =>
        this.parameterForm.controls.value.setValue(
          value.toString().replace(',', '.')
        )
      );
  }

  verifyAdding() {
    const request = {
      name: this.parameterForm.controls.parameter.value,
      validFrom: this.parameterForm.controls.dateFrom.value?.toISODate(),
      validTo: this.parameterForm.controls.dateTo.value?.toISODate(),
      value: this.parameterForm.controls.value.value,
    };
    this.parameterService.add(request).subscribe({
      next: (result) => {
        this.dialogRef.close(result);
      },
      error: (error) => {
        this.handleError(error);
      },
    });
  }

  private handleError(error: any) {
    this.dialog.open(ErrorDialogComponent, {
      data: { message: error.error.Message },
    });
  }
}
